import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { createEffect } from '@ngrx/effects';
import { filter, map, mergeMap, tap } from 'rxjs/operators';
import { PageService } from '@app/b2b/core/cms/services/cms.service';

@Injectable()
export class CmsEffects {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private pageService: PageService,
  ) {}

  loadPageData$ = createEffect(
    () =>
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(route => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        mergeMap(route => route.data),
        tap(page => {
          this.pageService.loadPage(page);
        }),
      ),
    { dispatch: false },
  );
}
